<template>
  <div v-if="isModalOpen" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Detalle de Evaluación</h2>
        <button class="close-btn" @click="closeModal">×</button>
      </div>
      <div class="modal-body">
        <div v-if="filledData.evaluatable_type === 'App\\Models\\IndividualPlan'" class="p-4 border rounded-lg shadow-md">
          <h2 class="text-lg font-bold mb-2">Evaluación de mejora de competencias</h2>
          <p><strong>Año:</strong> {{ filledData.evaluatable.year }}</p>
          <div v-for="competency in filledData.evaluatable.competencies" :key="competency.id" class="mt-4 p-2 border rounded">
            <p class="text-sm text-gray-700">Competencia: {{ competency.competency.name }}</p>
            <p class="italic text-sm text-gray-600">Plan de mejora: {{ competency.improvement_plan }}</p>

            <!-- Mostrar las respuestas relacionadas con la competencia -->
            <div v-if="filledData.plan_individual_responses && filledData.plan_individual_responses.length > 0">
              <p class="font-semibold text-gray-800 mt-2">Porcentaje de mejora:</p>
                <span v-for="response in filledData.plan_individual_responses" :key="response.id" class="text-sm text-gray-600">
                  <strong v-if="competency.competency_id === response.plan_competency.competency_id">{{ response.progress_percentage }} % </strong> 
                </span>
            </div>
          </div>
        </div>
        <div v-if="filledData.evaluatable_type === 'App\\Models\\ScopeEvaluation'" class="p-4 border rounded-lg shadow-md">
          <h2 class="text-lg font-bold mb-2">Evaluación Cumplimiento de Objetivos</h2>
          <p><strong>Fecha:</strong> {{ filledData.evaluatable.created_at }}</p>
          <div v-for="goal in filledData.evaluatable.goals" :key="goal.id" class="mt-4 p-2 border rounded">
            <p class="text-sm text-gray-700">Competencia: {{ goal.objective }}</p>
            <!-- Mostrar las respuestas relacionadas con la competencia -->
            <div v-if="filledData.scope_goal_responses && filledData.scope_goal_responses.length > 0">
              <p class="font-semibold text-gray-800 mt-2">Porcentaje de cumplimiento:</p>
                <span v-for="response in filledData.scope_goal_responses" :key="response.id" class="text-sm text-gray-600">
                  <strong v-if="goal.id === response.scope_goal_id">{{ response.intermediate_fulfillment }} % </strong> 
                </span>
            </div>
          </div>
        </div>

        <div v-if="filledData.evaluatable_type === 'App\\Models\\Evaluation'" class="p-4 border rounded-lg shadow-md">
          <h2 class="text-lg font-bold mb-2">Evaluación de competencias</h2>
          <p><strong>Fecha:</strong> {{ filledData.created_at }}</p>
          <div v-for="goal in filledData.evaluatable.competencies" :key="goal.id" class="mt-4 p-2 border rounded">
            <h3 class="text-sm text-gray-700">Competencia: {{ goal.name }}</h3>
            <!-- Mostrar las respuestas relacionadas con la competencia -->
            <div v-if="goal.questions && goal.questions.length > 0">
                <p v-for="(question , index) in goal.questions" :key="index" class="text-sm text-gray-600">
                  <strong>{{ index + 1}} - {{ question.question_text }}  </strong>  <br>
                    <span v-for="(response) in filledData.evalution_responses" :key="response.id" class="text-sm text-gray-600">
                    <b v-if="response.question && response.question.id === question.id"> Puntaje : {{ response.response_option.score }} Pts</b> 
                  </span>
                </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="close-modal-btn" @click="closeModal">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../services/request";

export default {
  name: "FilledEvaluationModal",
  props: {
    isModalOpen: Boolean,
    evaluationId: Number,
    userId: Number, // Nueva propiedad userId
  },
  data() {
    return {
      filledData : [],
      competencies: [],
      availableCompetencies: [],
      addedCompetencies: [],
      solutions: [],
      selectedCompetency: null,
      loading: false,
    };
  },
  watch: {
    evaluationId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchCompetencies(newVal);
        }
      },
    },
  },
  computed: {
    isFormValid() {
      return (
        this.addedCompetencies.length >= 2 &&
        this.solutions.every(
          (solution) => solution && solution.trim().length >= 50
        )
      );
    },
  },
  methods: {
    async fetchCompetencies(evaluationId) {
      this.loading = true;
      try {
        const { data } = await request.get(`/evaluations/filled/${evaluationId}`);
        this.filledData = data.data;
      } catch (error) {
        console.error("Error al obtener las competencias:", error);
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.$emit("closeFilled");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
.modal-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  width: 95%; /* Ajuste para hacerlo más ancho */
  max-width: 1200px; /* Límite máximo de ancho */
  max-height: 80%;
  overflow-y: auto;
}
.invalid-input {
  border: 1px solid red;
}
.competency-select {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.select-input {
  flex: 1;
  padding: 8px;
  margin-right: 10px;
}
.add-btn {
  background-color: #1d4745;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.add-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.competency-item {
  margin-bottom: 20px;
}
.solution-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  resize: none;
  height: 80px;
}
.remove-btn {
  margin-top: 10px;
  background-color: #d9534f;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.remove-btn:hover {
  background-color: #c9302c;
}
.submit-btn {
  background-color: #1d4745;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.close-modal-btn {
  background-color: #6c757d;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
